export default "__VITE_ASSET__CzvEeHh7__"